import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'dmp-select-icon',
    templateUrl: './select-icon.component.html',
    styleUrls: ['./select-icon.component.scss'],
    standalone: false
})
export class SelectIconComponent {
    @Input() actualIcon: string;

    iconOptions: string[] = [
        'pi pi-cog',
        'pi pi-envelope',
        'pi pi-calendar',
        'pi pi-eye',
        'pi pi-globe',
        'pi pi-shopping-cart',
        'pi pi-megaphone',
        'pi pi-credit-card',
        'pi pi-shopping-bag',
        'pi pi-user-plus',
        'pi pi-users',
        'pi pi-wallet'
    ];

    selectedIcon: string;
    iconPickerDialog: boolean = false;

    @Output() onSave = new EventEmitter<string>();

    constructor(
        private translate: TranslateService
    ) { }

    ngOnInit() { }

    openIconPicker() {
        this.selectedIcon = this.actualIcon;
        this.iconPickerDialog = true;
    }

    cancelIconPicker() {
        this.iconPickerDialog = false;
    }

    resetIconPicker() {
        this.selectedIcon = null;
        this.applyIconPicker();
    }

    applyIconPicker() {
        this.iconPickerDialog = false;
        this.onSave.emit(this.selectedIcon);
    }

    selectIcon(icon: string) {
        this.selectedIcon = icon;
    }

}